import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { META_ID_APP } from "core/config/environment";
import { LoadingButton } from "@mui/lab";
import FacebookIcon from "@mui/icons-material/Facebook";

interface Props {
  setAuth: Dispatch<SetStateAction<boolean>>;
  onFacebookCallback: (userInfo: any) => void;
}

const MetaLogin: React.FC<Props> = ({ setAuth, onFacebookCallback }) => {
  const { t } = useTranslation();

  const responseFacebook = (response: any) => {
    onFacebookCallback(response);
    setAuth(true);
  };

  return (
    <>
      <FacebookLogin
        appId={META_ID_APP}
        autoLoad={false}
        fields="name, email, picture"
        callback={responseFacebook}
        scope="email, pages_show_list, business_management, instagram_basic, instagram_manage_insights, pages_read_engagement, pages_read_user_content, public_profile"
        render={(renderProps) => (
          <LoadingButton
            variant="contained"
            onClick={renderProps.onClick}
            loading={renderProps.isProcessing}
            startIcon={<FacebookIcon />}
          >
            {t("login.facebook").toUpperCase()}
          </LoadingButton>
        )}
      />
    </>
  );
};

export default MetaLogin;
